// system.js
import api from './api';

export const getSystemStatus = async () => {
  try {
    const response = await api.get('/system/status');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch system status:', error);
    return { status: 'offline', last_updated: new Date().toISOString() };
  }
};

export const getSystemStats = async () => {
  try {
    const response = await api.get('/system/stats');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch system stats:', error);
    return { uptime: 0, memory_usage: 0, cpu_usage: 0 };
  }
};